import { render, staticRenderFns } from "./ModifyDialog.vue?vue&type=template&id=683057a4&scoped=true"
import script from "./ModifyDialog.vue?vue&type=script&lang=js"
export * from "./ModifyDialog.vue?vue&type=script&lang=js"
import style0 from "./ModifyDialog.vue?vue&type=style&index=0&id=683057a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683057a4",
  null
  
)

export default component.exports